








































































































































































































































































































































































































































































































































































































































































































































































































































































































































import { Vue, Component } from "vue-property-decorator";

export type TermsForFixedPriceModelModalResult = {
  type: "Cancel";
};

@Component
export default class TermsForFixedPriceModelModal extends Vue {
  dialog = false;
  resolve: ((v: TermsForFixedPriceModelModalResult) => void) | null = null;

  open(): Promise<TermsForFixedPriceModelModalResult> {
    this.dialog = true;

    return new Promise<TermsForFixedPriceModelModalResult>(resolve => {
      this.resolve = resolve;
    });
  }

  $refs!: Vue["$refs"] & {};

  cancel() {
    if (this.resolve) {
      this.resolve({
        type: "Cancel",
      });
    }
    this.dialog = false;
  }
}
